import { Button as MuiButton, ButtonProps } from "@mui/material";

interface Props extends ButtonProps {}

export const Button = (props: Props) => {
  return (
    <MuiButton variant="contained" size="medium" disableRipple {...props} />
  );
};
